<span
  class="date"
  [class.date--show-tooltip]="!!tooltipFormat"
  [attr.title]="
    tooltipFormat && (date | ftrDate: { format: tooltipFormat, toMoment: toMoment, defaultValue: defaultValue })
  "
  >{{ date | ftrDate: { format: format, toMoment: toMoment, defaultValue: defaultValue } }}</span
>
